import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "option-input__label" }

import { QuestionnaireFormOption } from '@/models/onboarding.types'
import OptionInput from './OptionInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionCheckbox',
  props: {
    modelValue: null,
    option: null,
    maxOptions: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string[]
  option: QuestionnaireFormOption
  maxOptions?: number
};





function updateValue(event: Event): void {
  const input = event.target as HTMLInputElement
  if (!input) {
    return
  }
  const newValue = [...props.modelValue]

  if (input.checked) {
    newValue.push(input.value)
  } else {
    const index = newValue.indexOf(input.value)
    if (index !== -1) {
      newValue.splice(index, 1)
    }
  }

  emit('update:modelValue', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OptionInput, {
    type: "checkbox",
    value: __props.option.label,
    modelValue: __props.modelValue,
    updateFn: updateValue,
    option: __props.option,
    maxOptions: __props.maxOptions,
    class: "option-input--checkbox"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.option.label), 1)
    ]),
    _: 1
  }, 8, ["value", "modelValue", "option", "maxOptions"]))
}
}

})